import React, { useRef, useState, useEffect } from 'react';

//Drag -beautiful-dnd
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

//actions
import { basicMsg } from '../../../../actions/swal_msg';

//MUI
import {
    Button, Grid, IconButton, Box
} from '@mui/material';
import { styled } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

//Regex
import { regex_file_ext } from '../../../../constants/regex';
import { GOOGLE_DRIVE_CDN } from '../../../../constants/constants';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const ImagesContainer = ({ images, setProdValues, onDeleteRemote }) => {
    const fileInputRef = useRef();
    // se utiliza para modificar nombre de archivos/imágenes repetidas
    const [counter, setCounter] = useState(0);

    useEffect(() => {
        fileInputRef.current.value = "";
    }, [images]);

    const handleOnDragEnd = (result) => {
        if (!result.destination) return;

        const items = Array.from(images);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);

        setProdValues(e => ({
            ...e,
            additional_images: items
        }));
    };

    // remueve imagen de producto
    const removeImg = image => async() => {
        if (image.id && onDeleteRemote) {
            const removed = await onDeleteRemote(image.id);
            if (!removed)
                return;
        }
        setProdValues(e => ({
            ...e,
            additional_images: e.additional_images.filter(e =>
                (e.id || e.name) !== (image.id || image.name)
            )
        }));
    };

    const loadImages = async ({ target }) => {
        let count = images.length; // total de imágenes
        let duplicate_img = false;
        let exceeded = false; // se alcanzó el límite?
        if (count >= 20) {
            basicMsg('No puede agregar más imágenes');
            return;
        }
        if (target.files.length > 0) {
            let target_files = [];
            // [...target.files].forEach(element => {
            for (const element of [...target.files]) {
                if (count >= 20) exceeded = true;
                else {
                    const { name, type } = element;
                    // archivo es una imagen compatible
                    if (['image/jpeg', 'image/png', 'image/webp'].includes(type)) {
                        const file_ext = regex_file_ext.exec(name)[1];
                        if (file_ext) { // extensión es válida
                            // mismo archivo ya se ha subido => editar nombre
                            if (images.find(e => e.name === name)) {
                                // nuevo nombre de archivo
                                // nombre anterior sin extensión + contador + . + extensión
                                const file_name = `${name.replace(/\.[^/.]+$/, "")}_${counter}.${file_ext}`;
                                target_files = [
                                    ...target_files, new File([element], file_name, { type })
                                ];
                                duplicate_img = true;
                            } else
                                target_files = [...target_files, element];
                            count++;
                        }
                    }
                }
            };
            if (duplicate_img) // hubo por lo menos una imagen duplicada
                setCounter(counter + 1);
            setProdValues(e => ({
                ...e,
                additional_images: [...e.additional_images, ...target_files]
            }));
            if (exceeded) basicMsg('Se alcanzó el límite de imágenes (20)');
        }
    };

    return (
        <>
            <DragDropContext onDragEnd={handleOnDragEnd}>
                <Droppable droppableId="product-images">
                    {(provided) => (
                        <Grid container spacing={3}
                            {...provided.droppableProps}
                            ref={provided.innerRef}>
                            {
                                images.length > 0 &&
                                images.map((e, i) => {
                                    const name = e.name || e.id;
                                    const src = e.id
                                        ? `${GOOGLE_DRIVE_CDN}${e.id}`
                                        : URL.createObjectURL(e);
                                    return (
                                        <Draggable key={name}
                                            draggableId={name} index={i}>
                                            {(provided) => (
                                                <Grid item xxl={3} xl={4} lg={6} md={6} sm={12} xs={12}>
                                                    <Box sx={{ position: 'relative' }}
                                                        key={i}
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                    >
                                                        <Box
                                                            component='img'
                                                            src={src}
                                                            alt={e.alt || 'producto-add-images'}
                                                            sx={{
                                                                width: '100%',
                                                                height: 250,
                                                                objectFit: 'cover',
                                                                borderRadius: '4px'
                                                            }}
                                                        />
                                                        <Box sx={{ position: 'absolute', top: 5, right: 5 }}>
                                                            <IconButton onClick={removeImg(e)}
                                                                sx={[
                                                                    {
                                                                        '&:hover': {
                                                                            backgroundColor: '#C11007',
                                                                        },
                                                                        backgroundColor: '#E7180B',
                                                                        width: '35px',
                                                                        height: '35px'
                                                                    },
                                                                ]}
                                                            >
                                                                <DeleteIcon sx={{ color: '#fff' }} fontSize='small' />
                                                            </IconButton>
                                                        </Box>
                                                    </Box>
                                                </Grid>
                                            )}
                                        </Draggable>
                                    );
                                })
                            }
                            {provided.placeholder}
                        </Grid>
                    )}
                </Droppable>
            </DragDropContext>
            <Button sx={{ mt: 2 }}
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                startIcon={<CloudUploadIcon />}
            >
                Subir imágenes
                <VisuallyHiddenInput
                    ref={fileInputRef}
                    accept="image/*" type="file"
                    onChange={loadImages} multiple
                />
            </Button>
        </>
    );
};

export default ImagesContainer;
